import React, { useState } from "react";


import { formatPrice, formatTitleInUrl, CarTransmission, CarFuel } from "../../../common/common";


import { IcTransmission, IcFuel } from "../../../common/svg"
import car_photo from "../../../../static/images/upload/car_1.png";

const CSItem = ({car, togglePopup, isNewTab}) => {

	const priceSummary = car?.years && car?.years.length > 0 ?  car.years[0].priceSummary?.filter(price => price.totalMonths === 6)[0] : {}
	const totalDiscountPercent = priceSummary && priceSummary.specialDiscount > 0 ? parseInt(priceSummary.specialDiscount/priceSummary.priceOrigin*100) : 0
	const totalMonthDiscount = priceSummary && priceSummary.totalMonths
	return (
        <a
        href={`/carsubscription/${formatTitleInUrl(car?.name)}/${car?.skuGroupId}`}
        target={"_blank"}
        onClick={(e) => {
            if (isNewTab) {
                e.preventDefault();
				togglePopup(car);
                return false;
            }
        }}
        className={`item item-car`}>
		
				<div className="item-box"> 
				<div className="img-car"> 
					<div className="fix-img"><img loading="lazy" src={car?.thumbUrl ? car.thumbUrl : car_photo} /></div>
				</div>
				<div className="info-car">
					<p className="name fontWeight-8">{car?.name}</p>
					<div className="desc-tag"> 
					<div className="tag-item"> 
						<div className="wrap-svg"> 
							<IcTransmission />
						</div>
						<p className="font-14 fontWeight-5">{CarTransmission[car?.transmission]}</p>
					</div>
					<div className="tag-item"> 
						<div className="wrap-svg">
							<IcFuel />
						</div>
						<p className="font-14 fontWeight-5">{CarFuel[car.fuel]}</p>
					</div>
					</div>
				</div>
				<div className="desc-car"> 
					<div className="price-item d-flex-center"> 
					<div className="info">
						{car.years && car.years[0] && car?.years[0].priceSummary !== undefined && car?.years[0]?.priceSummary.map((price) => { 
							if (price.totalMonths === 6) {
								return <div className="price-m"> 
									<p className="old-price">{formatPrice(price.priceOrigin)}</p>
									<h5 className="dis-price">&nbsp;{formatPrice(price.priceSpecial)}<span>&nbsp;/tháng</span></h5>
								</div>}
							})} 
						{/* {totalDiscountPercent > 0 && <span class="discount">Giảm {totalDiscountPercent}%</span>} */}
						{car?.years && car.years.length > 0 && totalDiscountPercent > 0 && <div className="note">Ưu đãi <span className="text-primary fontWeight-8">{totalDiscountPercent}% </span>khi thuê từ <span className="text-primary fontWeight-8">{totalMonthDiscount} tháng </span>trở lên</div>}
					</div>
					<a className="btn btn-primary btn--m" onClick={(e) => {
								if (isNewTab) {
									togglePopup(car);
								}
							}}>Chọn xe</a>
					</div>
				</div>
				</div>
	

			
        </a>
	);
};

export default CSItem;

